import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Radio, Select } from 'antd';
import Balance from '../../../../../assets/Balance.jsx';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { UniPaymentDepositAmountApi } from '../../../../../api/request/wallet/deposit.js';
import { handleApiError } from '../../../../../utils/handleApiError.js';
import { getDepositAmountError } from '../../../../../utils/validateDepositAmount.js';
import { useResponsive } from '../../../../../hooks/useResponsive.js';

const UniPayment = ({ amount, paymentMethod, accounts, resetAll, loginTerminalId, validateAmount, tncFileUrl }) => {
    const { isMobile } = useResponsive();
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [isDepositLoading, setIsDepositLoading] = useState(false);

    const handleSubmit = async (values) => {
        setIsDepositLoading(true);
        try {
            const amountError = validateAmount || getDepositAmountError(amount, paymentMethod);
            if (amountError) {
                toast.error(amountError);
                return;
            }
            const isWallet = loginTerminalId === 'wallet';
            const deposiParams = {
                userId: userDetails?._id,
                paymentGatwayId: paymentMethod?.id,
                amount: Number(amount),
                loginTerminalId: isWallet ? 0 : loginTerminalId,
            };
            const { data } = await UniPaymentDepositAmountApi(deposiParams);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                resetAll();
                window.location.href = data?.data?.data?.invoice_url;
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsDepositLoading(false);
        }
    };

    return (
        <div>
            <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>


                <Form.Item
                    name='conditions'
                    valuePropName="checked"
                    rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                >
                    <Checkbox className='mt-4'>
                        Yes, I agreed to the{' '}
                        {tncFileUrl && (
                            <a href={tncFileUrl} target="_blank" rel="noopener noreferrer" className="primary underline hover:underline duration-300">Terms & Conditions</a>
                        )}
                    </Checkbox>
                </Form.Item>

                <LoadableButton
                    className={`text-sm text-white font-semibold rounded-lg px-12 uppercase themeHover duration-500 ${isMobile ? 'bg-primary py-3 w-full' : 'bg-primary py-2'}`}
                    type="submit"
                    lable='Submit'
                    isLoading={isDepositLoading}
                    loadingLable='Adding request...'
                />
            </Form>
        </div>
    )
}


export default UniPayment
